var _linearGradient, _path, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 36,
    y1: 3.005,
    x2: 36,
    y2: 101,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#002d44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#013852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0a4d6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    stopColor: "#0f5e82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#0f6d96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#0d77a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#0a7eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0881b2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7V99H0V1h45z",
    fillOpacity: 0,
    stroke: "#01415e",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 76.7h5.3c1.2 0 2.1.1 2.8.3.8.2 1.6.7 2.2 1.3.6.6 1.1 1.4 1.4 2.3.3.9.5 2 .5 3.4 0 1.2-.1 2.2-.4 3-.4 1-.9 1.9-1.5 2.5-.5.5-1.2.9-2.1 1.1-.6.2-1.5.3-2.6.3H6.2V76.7zm2.9 2.5v9.5h2.2c.8 0 1.4 0 1.8-.1.5-.1.9-.3 1.2-.6.3-.3.6-.7.8-1.4.2-.6.3-1.5.3-2.6s-.1-2-.3-2.5c-.2-.6-.5-1.1-.8-1.4-.4-.3-.8-.6-1.4-.7-.4-.1-1.2-.1-2.4-.1H9.1zM20.2 84c0-1.5.2-2.7.7-3.7.3-.7.8-1.4 1.3-2s1.2-1 1.9-1.3c.9-.4 1.9-.6 3.1-.6 2.1 0 3.8.7 5.1 2s1.9 3.1 1.9 5.5c0 2.3-.6 4.1-1.9 5.4s-3 2-5.1 2c-2.2 0-3.9-.6-5.1-1.9-1.3-1.3-1.9-3.1-1.9-5.4zm3-.1c0 1.6.4 2.8 1.1 3.7s1.7 1.3 2.9 1.3 2.1-.4 2.9-1.2c.7-.8 1.1-2.1 1.1-3.7s-.4-2.9-1.1-3.7c-.7-.8-1.7-1.2-2.9-1.2s-2.2.4-2.9 1.2c-.7.7-1.1 1.9-1.1 3.6zm22.5 1.9l2.8.9c-.4 1.6-1.2 2.7-2.2 3.5-1 .8-2.3 1.1-3.8 1.1-1.9 0-3.5-.6-4.7-1.9-1.2-1.3-1.8-3.1-1.8-5.4 0-2.4.6-4.2 1.9-5.6s2.9-2 4.9-2c1.8 0 3.2.5 4.3 1.6.7.6 1.2 1.5 1.5 2.6l-2.9.7c-.2-.7-.5-1.3-1.1-1.8s-1.2-.6-2-.6c-1.1 0-1.9.4-2.6 1.1s-1 2-1 3.7c0 1.8.3 3.1 1 3.9s1.5 1.2 2.6 1.2c.8 0 1.4-.2 2-.7.5-.5.9-1.3 1.1-2.3zm5.3 5.3V76.7h4.4l2.6 9.8 2.6-9.8H65V91h-2.7V79.8l-2.9 11.3h-2.8l-2.9-11.3v11.3H51z",
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 18.121,
    y1: 50.468,
    x2: 55.041,
    y2: 87.389,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#006186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    stopColor: "#005f83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#005a7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#005373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#004865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#003953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#00253c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#00031d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4 25.7c-.5 0-1 .2-1.4.3-.5.2-1 .4-1.4.6-.7.4-1.2.8-1.5 1.3-.3.5-.6 1.1-.8 1.7-.9 2.4-2.2 6-4 11.3-1.8 5.1-3.6 10.5-5.6 16H45l-8.7-24.4-7.9 24.4h-4.7c-2.6-7.5-4.6-13.3-6-17.2-1.4-4.1-2.5-7.4-3.5-10.2-.3-.8-.6-1.4-1-1.8-.4-.4-.9-.8-1.4-1.2-.4-.3-.9-.5-1.3-.6-.5-.1-1-.2-1.6-.3v-1.8h17.6v1.8c-1 .1-1.8.2-2.3.4-.5.1-.9.2-1.2.4-.3.1-.5.3-.5.4-.1.1-.1.3-.1.4 0 .2 0 .4.1.6.1.2.1.4.2.7.4 1.2 1.1 3.5 2.3 6.8 1.1 3.4 2.5 7.5 4.2 12.5L36.7 24h4.9l8.7 24.5c1.3-4 2.3-7.2 3.1-9.7.8-2.5 1.4-4.7 1.9-6.4.3-1.1.6-2 .7-2.8.2-.7.3-1.4.3-1.9 0-.3-.2-.6-.5-.8-.3-.2-.7-.4-1.2-.6-.4-.1-1-.3-1.7-.3-.7-.1-1.3-.2-1.8-.2v-2h13.3v1.9z",
    fill: "url(#b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 45.069,
    y1: 74.205,
    x2: 58.569,
    y2: 87.705,
    gradientTransform: "matrix(1 0 0 -1 0 102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#dff1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#dceef7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#d3e4ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#c4d6e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#b1c5d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#9ab0c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#819ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#64829f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#426c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#06577a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#015679"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fill: "url(#c)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1l27 26.7H45V1z",
    fillOpacity: 0,
    stroke: "#01415e",
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocm);
export default __webpack_public_path__ + "static/media/docm.10ade2ce016276de43979fe95b56c0d0.svg";
export { ForwardRef as ReactComponent };